import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "../features/langSlice";
import { useGetContentsQuery } from "../features/contentsApiSlice";

import { Buffer } from "buffer";
import Loader from "./elements/Loader";
import CustomLink from "./CustomLink";

const Policy = () => {
  const id = Buffer.from("2").toString("base64");
  const selectedLang = useSelector(selectCurrentLanguage);
  const [lang, setLang] = useState();
  const [data, setData] = useState([]);

  const [skip] = useState(false);
  const {
    data: fetchContents,
    isSuccess,
    isLoading,
    refetch,
  } = useGetContentsQuery({ id: id, lang: lang, skip: skip });

  useEffect(() => {
    setLang(selectedLang === "us" ? "en" : selectedLang);

    refetch();
  }, [refetch, lang, selectedLang]);

  useEffect(() => {
    if (isSuccess) {
      setData(fetchContents.data);
    }
  }, [fetchContents, isSuccess]);

  return (
    <>
      <section className="t-flex t-flex-col t-min-h-[100px]">
        <div className="t-pt-6">
          <div className="container ">
            <nav aria-label="Page breadcrumb">
              <h2 className="title2 !t-text-[24px]" style={{ fontFamily: "'DM Serif Display', serif" }}>{data.title}</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  <CustomLink
                    to={"/"}
                    className="breadcrumb-item  !t-text-gray-500"
                  >
                    Home
                  </CustomLink>
                </li>
                <li className="breadcrumb-item  !t-text-gray-500">
                  {data.title}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>

      <section className="blog-details section-padding t-min-h-[100vh]">
        <div className="container">
          <div className="row gx-sm-5 gy-4">
            <div className="col-xl-12">
              <div className="blog-detail-inner" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                <span dangerouslySetInnerHTML={{ __html: data.contents }} />
              </div>
            </div>
          </div>
        </div>
      </section>
      {isLoading && <Loader />}
    </>
  );
};

export default Policy;
